import PricingRangeDisplay from './PricingRangeDisplay'

export default PricingRangeDisplay
